(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('it')) return;

  const translations = new Map([
    ['Select the Types of Cookies You Accept', 'Seleziona i tipi di cookie che accetti'],
    ['Necessary', 'Necessari'],
    ['Essential for the website to function properly, these cookies enable core features such as security, page navigation, and access to secure areas. They cannot be disabled.', 'Indispensabili per il corretto funzionamento del sito: permettono sicurezza, navigazione e accesso alle aree protette. Non possono essere disattivati.'],
    ['Statistics', 'Statistiche'],
    ['By collecting anonymous data, these cookies help us understand how visitors interact with the website, allowing us to improve performance and user experience.', 'Raccogliendo dati anonimi, questi cookie ci aiutano a capire come viene utilizzato il sito e a migliorarne prestazioni ed esperienza.'],
    ['These cookies track your activity across websites to deliver personalized ads and relevant content. They also help measure the effectiveness of our marketing campaigns.', 'Questi cookie rilevano l’attività tra diversi siti per mostrare annunci e contenuti pertinenti e per misurare l’efficacia delle campagne di marketing.'],
    ['Preferences', 'Preferenze'],
    ['These cookies remember your choices — such as language preferences or login details — to provide a more personalized experience.', 'Questi cookie ricordano le tue scelte, come la lingua o i dati di accesso, per offrirti un’esperienza più personalizzata.'],
    ['Save my choice', 'Salva le mie scelte'],
    ['Reject All', 'Rifiuta tutti'],
    ['Accept All', 'Accetta tutti'],
    ['Powered by', 'Fornito da']
  ]);

  let observedRoot = null;
  let shadowObserver = null;

  const translateRoot = (root) => {
    root.querySelectorAll('*').forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const value = node.nodeValue.trim();
        const translated = translations.get(value);
        if (!translated) return;
        node.nodeValue = node.nodeValue.replace(value, translated);
      });

      ['aria-label', 'title'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        const translated = value && translations.get(value.trim());
        if (translated) element.setAttribute(attribute, translated);
      });
    });
  };

  const connect = () => {
    const host = document.querySelector('csm-cookie-consent');
    const root = host && host.shadowRoot;
    if (!root) return;

    if (root !== observedRoot) {
      if (shadowObserver) shadowObserver.disconnect();
      observedRoot = root;
      shadowObserver = new MutationObserver(() => translateRoot(root));
      shadowObserver.observe(root, { childList: true, subtree: true, characterData: true });
    }

    translateRoot(root);
  };

  new MutationObserver(connect).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', connect, { once: true });
  connect();

  let attempts = 0;
  const timer = setInterval(() => {
    connect();
    attempts += 1;
    if (attempts >= 60) clearInterval(timer);
  }, 500);
})();